import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sparkling-animation',
  templateUrl: './sparkling-animation.component.html',
  styleUrls: ['./sparkling-animation.component.scss']
})
export class SparklingAnimationComponent implements OnInit {
  @Input() showSparkles: any;
  constructor() {
  }

  ngOnInit() {
  }

  createRange(number) {
      const items: number[] = [];
      for (let i = 1; i <= number; i++) {
          items.push(i);
      }
      return items;
  }

}
